import React from 'react'

const Loading = (props) => (
  <div className={"indicator " + props.className} style={{ width: '100%', height: '100%', top: 0, left: 0 }}>
    {/* <div className="load">
            <hr />
            <hr />
            <hr />
            <hr />
        </div> */}
    <div className="spin-wrapper">
      <div className="spinner">
      </div>
    </div>
  </div>
);

export default Loading;